import { makeStyles } from '@material-ui/core/styles';
import { deviceMaxWidth, deviceMinWidth } from '../../constants';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
  },
  content: {
    margin: '30px 70px 125px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    [deviceMaxWidth.size600]: {
      margin: '0',
      flexDirection: 'column',
      width: '100%',
      padding: '0 30px 125px',
    },
  },
  audio: {
    height: '100%',
    marginRight: 30,
    display: 'flex',
    maxWidth: 550,
    flexDirection: 'column',

    [deviceMaxWidth.size500]: {
      width: '100%',
      marginRight: 0,
    },
    [deviceMinWidth.size1441]: {
      [deviceMaxWidth.size2560]: {
        maxWidth: 900,
      },
    },
  },
  filter: {
    display: 'flex',
    justifyContent: 'center',

    [deviceMaxWidth.size600]: {
      width: '100%',
      justifyContent: 'flex-start',
    },
  },
}));

export default useStyles;
